module.exports = __webpack_public_path__ + "img/Holzkloetze.7133a3db.jpg";